module.exports = __webpack_public_path__ + "2eb7acc61203926e4874d8ff332227e7.svg";